import React from "react";
import Button from "@mui/material/Button";
import { connect } from "react-redux";

import "./style.scss";
import QAImage from "../../../assets/images/qa-dark.png";
import QAImageLight from "../../../assets/images/qa.png";

const Supports = ({ selectNavigation, themeMode }) => {
  const goToSupport = () => {
    selectNavigation("support");
  };
  return (
    <div className="supports-widget">
      <div className="supports-widget-title">Support</div>
      <div className="supports-actions-wrapper">
        {/* <div className="supports-widget-item">
          <div className="supports-widget-item-detail">
            <img src={themeMode === 'light' ? FAQImageLight : FAQImage} className="supports-widget-faq-img" alt="faq" />
            <div>
              <div className="supports-widget-item-title">FAQ</div>
              <div className="supports-widget-item-info">Answers to your most common questions.</div>
            </div>
          </div>
          <Button className="supports-widget-item-button" onClick={goToFAQ.bind(this)}>How can we help?</Button>
        </div> */}

        <div className="supports-widget-item">
          <div className="supports-widget-item-detail">
            <img
              src={themeMode === "light" ? QAImageLight : QAImage}
              className="supports-widget-faq-img"
              alt="faq"
            />
            <div>
              <div className="supports-widget-item-title">Live Q&A</div>
              <div className="supports-widget-item-info">
                Eric Armenteros answers all your questions live.{" "}
              </div>
            </div>
          </div>
          <Button
            className="supports-widget-item-button"
            onClick={goToSupport.bind(this)}
          >
            Q&A Schedule
          </Button>
        </div>
      </div>
    </div>
  );
};

const stateToProps = (state) => ({
  themeMode: state.themeMode.themeMode,
});

const dispatchToProps = () => ({});

export default connect(stateToProps, dispatchToProps)(Supports);
